var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipPremiumSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_66937)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2674_66937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 35,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4488 8.09297L22.4459 1.79505C21.8229 1.40797 21.1224 1.1755 20.3958 1.07242C19.0981 0.865901 17.7228 1.09837 16.5552 1.79505L5.55194 8.09297C3.70955 9.15116 2.59375 11.0866 2.59375 13.1774V25.8244C2.59375 26.547 2.72349 27.2697 3.00905 27.9407C3.47617 29.1799 4.35859 30.238 5.55231 30.9088L16.5556 37.2063C18.3719 38.2645 20.6299 38.2645 22.4462 37.2063L33.4491 30.9088C34.0978 30.5217 34.6428 30.0571 35.11 29.4895C35.9402 28.4572 36.4073 27.1666 36.4073 25.8244V13.1774C36.4073 11.087 35.2915 9.15116 33.4488 8.09297Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2674_66937)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.99609,
    y: -4.99597,
    width: 73.983,
    height: 73.9506,
    fill: "url(#paint0_linear_2674_66937)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.456 26V14.144H20.344C21.2187 14.144 22.0027 14.2613 22.696 14.496C23.4 14.7307 23.9547 15.12 24.36 15.664C24.776 16.1973 24.984 16.9333 24.984 17.872C24.984 18.768 24.776 19.5093 24.36 20.096C23.9547 20.672 23.4053 21.0987 22.712 21.376C22.0293 21.6533 21.2613 21.792 20.408 21.792H18.824V26H16.456ZM18.824 19.92H20.248C21.0587 19.92 21.6613 19.7493 22.056 19.408C22.4613 19.0667 22.664 18.5547 22.664 17.872C22.664 17.1893 22.4507 16.7147 22.024 16.448C21.608 16.1707 20.9893 16.032 20.168 16.032H18.824V19.92Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2674_66937",
    x1: 9.45012,
    y1: -4.99597,
    x2: 52.5125,
    y2: 68.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7C1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_66937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipPremiumSmall);
export default __webpack_public_path__ + "static/media/image__membership-premium--small.a6ff1c7a57c4b7f1fe51cf76a1755ad5.svg";
export { ForwardRef as ReactComponent };